import httpDeviceClient from '../../httpDeviceClient';

export async function MerchantDevicesListRequest({ id, params }) {
  return httpDeviceClient.get(`/merchant/${id}/devices`, { params });
}
